<template>
    <div class="first-container d-flex" :class="{ 'opacity-50': isDisabled }" :data-original-url="node.url">
        <i class="material-icons drag-handler">drag_indicator</i>
        <i v-if="node.isMain" class="material-icons home-icon">home</i>
        <span class="page-title">
            {{ node.name }}
            <span v-if="node.url" class="page-url">({{ displayUrl }})</span>
        </span>
    </div>
    <div class="second-container d-flex align-items-center">
        <span class="page-type" :class="{ 'opacity-50': isDisabled }">{{ node.type }}</span>
        <div class="d-flex actions-container align-items-center">
            <div class="url-options">
                <i class="material-icons copy-url" @click="copyUrl" :data-copy="displayUrl">content_copy</i>
                <a :href="displayUrl" target="_blank" class="d-flex go-to-url"><i class="material-icons">open_in_new</i></a>
            </div>
            <a :href="node.actions.edit" class="btn btn-primary me-2 edit-button">
                <span class="material-icons me-1">mode_edit</span> <span class="edit-text">Edytuj</span>
            </a>
        </div>
        <div class="dropdown">
            <button class="btn btn-sm btn-secondary action-more dropdown-toggle page-menu" type="button" data-bs-toggle="dropdown" data-boundary="window" aria-expanded="false">
                <i class="material-icons">more_vert</i>
            </button>
            <ul class="dropdown-menu">
                <li class="change-page-status">
                    <button type="button" class="dropdown-item d-flex" @click="toggleStatus">
                        <span class="material-icons">{{ node.isActive ? 'visibility_off' : 'visibility' }}</span>
                        <span class="text">{{ node.isActive ? 'Dezaktywuj' : 'Aktywuj' }}</span>
                    </button>
                </li>
                <li class="additional-options">
                    <a :href="node.actions.edit" class="dropdown-item d-flex edit-button">
                        <span class="material-icons">mode_edit</span><span class="edit-text text">Edytuj</span>
                    </a>
                </li>
                <li class="additional-options">
                    <button type="button" class="dropdown-item d-flex copy-url" @click="copyUrl" :data-copy="displayUrl">
                        <span class="material-icons">content_copy</span>
                        <span class="text">Kopiuj URL</span>
                    </button>
                </li>
                <li class="additional-options">
                    <a :href="displayUrl" target="_blank" class="dropdown-item d-flex go-to-url">
                        <span class="material-icons">open_in_new</span>
                        <span class="text">Otwórz w nowej karcie</span>
                    </a>
                </li>
                <li class="delete-page" :class="{ 'd-none': node.isMain }">
                    <button type="button" class="dropdown-item d-flex" @click="deletePage">
                        <span class="material-icons">delete</span>
                        <span class="text">Usuń</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup>
    import { computed, reactive } from 'vue';
    import { copyToClipboard } from '../components/copy-to-clipboard';

    const props = defineProps(['node', 'csrfToken']);
    const node = reactive(props.node);
    const displayUrl = node.isMain ? '/' : node.url;
    const isDisabled = computed(() => node.level && !node.isActive);

    const toggleStatus = () => {
        fetch(node.actions.toggleStatus, {
            method: 'POST',
            body: new URLSearchParams({ _token: props.csrfToken }),
        }).then((response) => {
            if (response.redirected) {
                window.location.href = response.url;
            }

            node.isActive = !node.isActive;
            toggleChildrenStatus(node.children, node.isActive);
        });
    };

    const toggleChildrenStatus = (children, isActive) => {
        if (!children) return;
        children.forEach(item => {
            item.isActive = isActive;
            if (item.children && item.children.length > 0) {
                toggleChildrenStatus(item.children, isActive);
            }
        });
    };

    const copyUrl = () => {
        copyToClipboard(`${window.location.origin}${displayUrl}`);
    };

    const deletePage = () => {
        const el = document.getElementById('modal-delete');
        const form = document.getElementById('delete-form');
        bootstrap.Modal.getOrCreateInstance(el).show();
        el.querySelector('#modal-delete-button').onclick = async e => {
            e.preventDefault();
            form.setAttribute('action', node.actions.delete);
            form.submit();
        }
    };
</script>
